import template from './index.html'
import controller from './controller'

directive.vsName = 'rolesMainGrid'
directive.vsNgType = 'directive'

directive.$inject = []
function directive(){
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: { 
      authorityGroup: '=' 
    },
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default directive